import React from 'react';
import './style.css';
const Orders = () => {
  return (
    <div className='content'>
      <h1>Orders Page</h1>
      <p>this page show you orders</p>
    </div>
  );
};

export default Orders;
